import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { FormResponsesSidepanel } from 'modules/forms/components/FormResponses/FormRenderResponses/FormResponsesSidepanel'

type Data = {
  formId: string
  membershipId: string
  resourceType: string
  materializedFormResourceType: string
}

export const FormResponsesActivity: ActivityComponent<Data> = ({
  formId,
  membershipId,
  resourceType,
  materializedFormResourceType,
}) => {
  const { open, closeActivity } = useActivity()

  return (
    <FormResponsesSidepanel
      membershipId={membershipId}
      materializedFormResourceType={materializedFormResourceType}
      formId={formId}
      isOpen={open}
      onClose={closeActivity}
      resourceType={resourceType}
    />
  )
}
